// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideMenuSettings{
    max-width: 100%;
    max-height: 100%;
}

.SideMenuSettings_wallpapers{
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.SideMenuSettings_wallpaper_preview{
    border-radius: 5px;
    width: 100px;
    height: 100px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    font-size: 0;
}

.SideMenuSettings_wallpaper_preview--selected{
    outline: 2px #f90 solid;
}

.SideMenuSettings_timezone {
    margin-bottom: 20px;
}

.SideMenuSettings_timezoneSelect {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: white;
    font-size: 14px;
    color: #333;
    cursor: pointer;
}

.SideMenuSettings_timezoneSelect:focus {
    outline: none;
    border-color: #f90;
    box-shadow: 0 0 0 2px rgba(255, 153, 0, 0.2);
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/sideMenu/SideMenuSettings.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,sBAAsB;IACtB,kCAAkC;IAClC,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,4CAA4C;AAChD","sourcesContent":[".SideMenuSettings{\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.SideMenuSettings_wallpapers{\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n\n.SideMenuSettings_wallpaper_preview{\n    border-radius: 5px;\n    width: 100px;\n    height: 100px;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center center;\n    font-size: 0;\n}\n\n.SideMenuSettings_wallpaper_preview--selected{\n    outline: 2px #f90 solid;\n}\n\n.SideMenuSettings_timezone {\n    margin-bottom: 20px;\n}\n\n.SideMenuSettings_timezoneSelect {\n    width: 100%;\n    padding: 8px 12px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    background-color: white;\n    font-size: 14px;\n    color: #333;\n    cursor: pointer;\n}\n\n.SideMenuSettings_timezoneSelect:focus {\n    outline: none;\n    border-color: #f90;\n    box-shadow: 0 0 0 2px rgba(255, 153, 0, 0.2);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
